<template>
    <div v-if="hasAccess && isActive" class="login-dashboard-popup-link" v-text="data.name" @click="actionRedirect"></div>
</template>

<script>
    import DashboardPlatform from "../../new/pages/DashboardPlatform";

    export default {
        name: "LoginDashboardPopupPlatform",
        mixins: [DashboardPlatform],
        computed: {
            hasAccess() {
                let appAccesses = this.appAccesses.find(appAccess => {
                    return appAccess.appSlug === this.data.slug;
                });

                return appAccesses !== undefined && appAccesses.hasAccess;
            },
            isActive() {
                let appAccesses = this.appAccesses.find(appAccess => {
                    return appAccess.appSlug === this.data.slug;
                });

                return appAccesses !== undefined && appAccesses.isActive;
            },
        },
        methods: {
            actionRedirect() {
                window.top.postMessage({
                    action: 'redirect',
                    url: this.redirectHost,
                }, '*');
            }
        },
    }
</script>